import CourseOutline from "./course-outline";
import CourseOutlineRegistration from "./course-outline-registration";
import ClassSection from "./class-section";

export default {
  namespaced: true,
  modules: {
    CourseOutline,
    CourseOutlineRegistration,
    ClassSection
  }
}
